import BaseStore from 'customer-flows/stores/base-store'
import { tracked } from '@glimmer/tracking'
import { trackedAsync, type Awaitable } from 'customer-flows/utils/core'

export default class ProgramStoreClass extends BaseStore {
  @trackedAsync() program: Awaitable<ProgramType>

  @tracked initialLayoutName?: string

  get id(): string | undefined {
    return this.program.value?.id
  }

  get safeId(): string | undefined {
    return this.id?.split('--')[0]
  }

  get layoutName(): string | undefined {
    return this.program.value?.layoutName
  }

  get locale(): string | undefined {
    return this.program.value?.locale
  }

  get languageOverrides(): LanguageOverride[] | undefined {
    return this.program.value?.languageOverrides
  }

  get pricingTransparency(): boolean | undefined {
    return this.program.value?.pricingTransparency
  }

  get provider(): Provider | undefined {
    return this.program.value?.provider
  }

  get theme(): string | undefined {
    return this.program.value?.theme
  }

  get tracking(): TrackingConfiguration | undefined {
    return this.program.value?.tracking
  }

  get partnerId(): string | undefined {
    return this.program.value?.provider?.id
  }

  get isMultiProductFlow(): boolean {
    return ['TILES_V2'].includes(this.layoutName ?? '')
  }

  get orderTaxesFeesBreakdownMode(): OrderTaxesFeesBreakdownMode | undefined {
    const program = this.program.value
    if (program && 'orderTaxesFeesBreakdownMode' in program) {
      return (program as BookingFlow).orderTaxesFeesBreakdownMode
    }
    return undefined
  }

  get gaId(): string | undefined {
    return this.tracking?.ga?.split(';').find((id) => id.startsWith('GA-'))
  }

  get gtmId(): string | undefined {
    return this.tracking?.ga?.split(';').find((id) => id.startsWith('GTM-'))
  }

  get metaId(): string | undefined {
    return this.tracking?.fb
  }
}

declare global {
  export type ProgramStore = ProgramStoreClass
  export interface StoreRegistry {
    program: ProgramStore
  }
}
